/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1SerieMutationRequest,
  PostApiV1SerieMutationResponse,
  PostApiV1Serie400,
  PostApiV1Serie401,
  PostApiV1Serie404,
  PostApiV1Serie500,
} from "../../types/serieRegistroController/PostApiV1Serie.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPostApiV1SerieUrl() {
  const res = { method: "POST", url: `/api/v1/serie` as const };
  return res;
}

/**
 * @description Cria uma nova série (multipart/form-data) com título/resumo no idioma corrente, turmas (quando não é geral) e imagem de capa opcional. **(Requer Authorization para autenticação)**
 * @summary Criar série (Requer Authorization para autenticação)
 * {@link /api/v1/serie}
 */
export async function postApiV1Serie(
  data?: PostApiV1SerieMutationRequest,
  config: Partial<RequestConfig<PostApiV1SerieMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PostApiV1SerieMutationResponse,
    ResponseErrorConfig<
      | PostApiV1Serie400
      | PostApiV1Serie401
      | PostApiV1Serie404
      | PostApiV1Serie500
    >,
    PostApiV1SerieMutationRequest
  >({
    method: "POST",
    url: getPostApiV1SerieUrl().url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
